// start:ng42.barrel
import './subject-class.service';
import './components';
import './directives';
// end:ng42.barrel

